import React from 'react';
import MultiStep from '../../../../tc-ui/stepper-wizard';
import StepOne from './1-step-add-extra.jsx';
import StepTwo from './2-step-add-extra.jsx';

const AddExtra = ({
  RatesFormAndTable,
  addExtraStepper,
  updateCellValueForOfferRates,
  ...extraProps,
}) => {
  const stepNames = ['Add information', 'Review Rate Table'];
  return (
    <div>
      <MultiStep
        steps={stepNames}
        componentIndex={addExtraStepper}
        showStepsBar
      >
        <StepOne {...extraProps} extraRates={RatesFormAndTable} />
        <StepTwo {...extraProps} extraRates={RatesFormAndTable} updateTableCell={updateCellValueForOfferRates} />
      </MultiStep>
    </div>
  );
};

export default AddExtra;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/extras/add-extra-wizard.jsx